import link from 'link-text';

export default function formatComment(text) {
 return link(text, { target: '_blank' }).replace(/(?:\r\n|\r|\n)/g, '<br />').replace(/&#39;/g, '\'');
}